class AssertionError extends Error {
  constructor(value, that = "value to pass assertion") {
    super(`Expecting ${that}, ${JSON.stringify(value)} given`);
  }
}
export {
  AssertionError
};
//# sourceMappingURL=AssertionError.js.map
